import React, { useMemo } from "react";

import PropTypes from "prop-types";
import Spin from "shared/components/Spin";

import ProductBanner from "./Banner";
import ListCheckProduct from "./ListCheckProduct";
import ListNbrFacture from "./ListNbrFacture";
import ListOptions from "./ListOptions";
import ListProduct from "./ListProduct";
import ListProductFolder from "./ListProductFolder";

const TYPE = {
  listProduct: ListProduct,
  listOptions: ListOptions,
  listNbrFacture: ListNbrFacture,
  listCheckProduct: ListCheckProduct,
  listProductFolder: ListProductFolder,
  banner: ProductBanner,
};

const Product = ({ type, loading, ...props }) => {
  const View = useMemo(() => TYPE[type], [type]);
  if (loading) {
    return <Spin />;
  }
  return <View {...props} />;
};

Product.propTypes = {
  type: PropTypes.oneOf(Object.keys(TYPE)),
  loading: PropTypes.bool,
};

Product.defaultProps = {
  type: "listProduct",
};

export default Product;
